'use client'

import { useTranslations } from 'next-intl'
import { motion } from 'framer-motion'
import { Calendar, Users, Zap, Shield } from 'lucide-react'

const features = [
  {
    icon: Calendar,
    titleKey: 'feature1Title',
    descriptionKey: 'feature1Description'
  },
  {
    icon: Users,
    titleKey: 'feature2Title',
    descriptionKey: 'feature2Description'
  },
  {
    icon: Zap,
    titleKey: 'feature3Title',
    descriptionKey: 'feature3Description'
  },
  {
    icon: Shield,
    titleKey: 'feature4Title',
    descriptionKey: 'feature4Description'
  }
]

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
}

const item = {
  hidden: { opacity: 0, scale: 0.95 },
  show: { opacity: 1, scale: 1 }
}

export const Features = () => {
  const t = useTranslations('features')

  return (
    <div className="w-full">
      <section id="features" className="container py-12 md:py-24">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-2xl md:text-3xl font-bold text-center mb-8 md:mb-12"
        >
          {t('title')}
        </motion.h2>
        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8"
        >
          {features.map((feature, index) => {
            const Icon = feature.icon
            return (
              <motion.div
                variants={item}
                transition={{ duration: 0.5 }}
                key={index}
                className="flex items-start gap-3 md:gap-4 p-4 md:p-6 rounded-lg border hover:border-orange-500 transition-colors bg-background"
              >
                <div className="w-12 h-12 md:w-16 md:h-16 rounded-full bg-orange-100 dark:bg-orange-900/20 flex items-center justify-center flex-shrink-0">
                  <Icon className="w-6 h-6 md:w-8 md:h-8 text-orange-500" />
                </div>
                <div>
                  <h3 className="text-lg md:text-xl font-semibold mb-2">{t(feature.titleKey)}</h3>
                  <p className="text-sm md:text-base text-muted-foreground">
                    {t(feature.descriptionKey)}
                  </p>
                </div>
              </motion.div>
            )
          })}
        </motion.div>
      </section>
    </div>
  )
}
